import VSelectCardState from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardState', VSelectCardState),
};
